module.exports = __webpack_public_path__ + "img/bg.35d24481.png";